// extracted by mini-css-extract-plugin
export default {"Container":"LoadingSpinner_Container__lsbJl","Spinner":"LoadingSpinner_Spinner__EE2K+","spin":"LoadingSpinner_spin__t0eJv"};